import {Action} from '../../actions';
import {SessionWithPayment} from '@nib/join-services-api';

const SUBMIT_JOIN = 'join/submit';

export const ActionTypes = {
  SUBMIT_JOIN_PENDING: `${SUBMIT_JOIN}_PENDING`,
  SUBMIT_JOIN_FULFILLED: `${SUBMIT_JOIN}_FULFILLED`,
  SUBMIT_JOIN_REJECTED: `${SUBMIT_JOIN}_REJECTED`
};

export interface JoinStatusState {
  submittingJoin?: boolean;
  fetchedJoin?: boolean;
}

export interface JoinState extends JoinStatusState {
  policyNumber?: number;
  joinId?: string;
  exceptionMessage?: string;
}

export interface SubmitJoinPayload {
  joinData: SessionWithPayment;
}

export interface SubmitJoinFulfilledPayload {
  joinId: string;
  policyNumber: number;
}

export interface SubmitJoinRejectedPayload {
  message: string;
}

interface SubmitJoinAction extends Action<SubmitJoinPayload> {
  type: typeof ActionTypes.SUBMIT_JOIN_PENDING;
  payload: SubmitJoinPayload;
}

interface SubmitJoinFulfilledAction extends Action<SubmitJoinFulfilledPayload> {
  type: typeof ActionTypes.SUBMIT_JOIN_FULFILLED;
  payload: SubmitJoinFulfilledPayload;
}

interface SubmitJoinRejectedAction extends Action<SubmitJoinRejectedPayload> {
  type: typeof ActionTypes.SUBMIT_JOIN_REJECTED;
  payload: SubmitJoinRejectedPayload;
}

export type JoinActionTypes = SubmitJoinAction | SubmitJoinFulfilledAction | SubmitJoinRejectedAction;
